/**
 * This file is part of the box.co.il project.

 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */
;(function($) {

  // set custom messages for validation errors
  $.validatorMessages({
    valid_email:       $.translate('Only English letters (a-z), numbers, periods, @<br><span>Example: Israel123@gmail.com</span>'),
    english:           $.translate('Only English letters (a-z)'),
    // company_name:      $.translate('Name Company Limited'),
    is_natural:        $.translate('Only digits (0-9)'),
    max_length:        $.translate('Up to {1} Characters'),
    length_one_or_two: $.translate('{1} characters'),
    password: [
      $.translate('At least 8 characters'),
      $.translate('At least one English letter (a-z)'),
      $.translate('Contain the number one (9-0)')
    ],
    one_word:  $.translate('First Name'),
    two_words: $.translate('Last Name'),
    street:    $.translate('Street is required with house num'),
    alpha_numeric_space_dot: $.translate('Only English letters (a-z), numbers (0-9)'),
    english_numeric:         $.translate('Only English letters (a-z), numbers (0-9)')

  });

  // forms validation rules
  window.validationRules = {};

  // address country selected in the field's form (zip / company number rules depend on it)
  var formCountry = function(field, countryName) {
    var form = $(field.element).closest('form');

    return form.find('[name="' + countryName + '"]').val();
  };

  var zipCallbacks = function(countryName) {
    return {
      callback_valid_zip_code: function(field) {
        return window.isValidZipForCountry(field.value, formCountry(field, countryName));
      }
    };
  };

  // IL / other countries are separate callbacks so each gets its own message
  var companyIdCallbacks = function(countryName) {
    return {
      callback_israeli_company_id: function(field) {
        var country = formCountry(field, countryName);

        return !window.isIsraelCountry(country) || window.isValidCompanyIdForCountry(field.value, country);
      },
      callback_foreign_company_id: function(field) {
        var country = formCountry(field, countryName);

        return window.isIsraelCountry(country) || window.isValidCompanyIdForCountry(field.value, country);
      }
    };
  };

  window.validationRules.companyIdMessages = {
    callback_israeli_company_id: $.translate('Company ID must be 9 digits starting with 5'),
    callback_foreign_company_id: $.translate('Company number is invalid')
  };

  var registerZipFieldRules = {
    rules: 'required|callback_valid_zip_code',
    messages: {
      required: false,
      callback_valid_zip_code: $.translate('Zip is invalid')
    },
    custom: zipCallbacks('country')
  };

  // #user-auth-register-company form
  window.validationRules.registerCompanyRules = {
    email: {
      rules: 'required|valid_email',
      messages: {
        required: false
      }
    },
    name: {
      rules: 'required|english_numeric|words_count_min[2]',
      messages: {
        required: false,
        words_count_min: false
      }
    },
    id: {
      rules: 'required|callback_israeli_company_id|callback_foreign_company_id',
      messages: $.extend({required: false}, window.validationRules.companyIdMessages),
      custom: companyIdCallbacks('country')
    },
    invoice: {
      rules: 'required|english_numeric',
      messages: {
        required: false
      }
    },
    tel1: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    tel3: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    tel4: {
      rules: 'required|is_natural',
      // disable validation if element is hidden
      depends: function(field) {
        var el = $(field.element);

        return !el.closest('.form-control-inner').hasClass('hidden');
      },
      messages: {
        required: false
      }
    },
    street_name: {
      rules: 'required|english',
      messages: {
        required: false
      }
    },
    street_number: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    city: {
      rules: 'required|english',
      messages: {
        required: false
      }
    },
    zip: registerZipFieldRules,
    password: {
      rules: 'required|password',
      messages: {
        required: false
      }
    },
    password2: {
      rules: 'required|matches[password]',
      messages: {
        required: false,
        matches: $.translate('The passwords does not match')
      }
    },
    approve_terms: {
      rules: 'required',
      messages: {
        required: false
      }
    }
  };

  // #user-auth-register-user form
  window.validationRules.registerUserRules = {
    email: {
      rules: 'required|valid_email',
      messages: {
        required: false
      }
    },
    name: {
      rules: 'required|one_word|two_words|english',
      messages: {
        required: false
      }
    },
    tel1: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    tel3: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    street_name: {
      rules: 'required|english',
      messages: {
        required: false
      }
    },
    street_number: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    city: {
      rules: 'required|english',
      messages: {
        required: false
      }
    },
    zip: registerZipFieldRules,
    password: {
      rules: 'required|password',
      messages: {
        required: false
      }
    },
    password2: {
      rules: 'required|matches[password]',
      messages: {
        required: false,
        matches: $.translate('The passwords does not match')
      }
    },
    approve_terms: {
      rules: 'required',
      messages: {
        required: false
      }
    },
    tel4: {
      rules: 'required|is_natural',
      // disable validation if element is hidden
      depends: function(field) {
        var el = $(field.element);

        return !el.closest('.form-control-inner').hasClass('hidden');
      },
      messages: {
        required: false
      }
    }
  };

  // Unified register form (private + company)
  window.validationRules.registerRules = {
    email: {
      rules: 'required|valid_email',
      messages: {
        required: false
      }
    },
    name: {
      rules: 'required|one_word|two_words|english',
      messages: {
        required: false
      }
    },
    id: {
      rules: 'required|callback_israeli_company_id|callback_foreign_company_id',
      depends: function(field) {
        var form = $(field.element).closest('form');
        return form.find('[name="clientType"]:checked').val() === 'company';
      },
      messages: $.extend({required: false}, window.validationRules.companyIdMessages),
      custom: companyIdCallbacks('country')
    },
    invoice: {
      rules: 'required|english_numeric',
      depends: function(field) {
        var form = $(field.element).closest('form');
        return form.find('[name="clientType"]:checked').val() === 'company';
      },
      messages: {
        required: false
      }
    },
    tel1: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    tel3: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    tel4: {
      rules: 'required|is_natural',
      depends: function(field) {
        var el = $(field.element);
        return !el.closest('.form-control-inner').hasClass('hidden');
      },
      messages: {
        required: false
      }
    },
    street_name: {
      rules: 'required|english',
      messages: {
        required: false
      }
    },
    street_number: {
      rules: 'required|is_natural',
      messages: {
        required: false
      }
    },
    city: {
      rules: 'required|english',
      messages: {
        required: false
      }
    },
    zip: registerZipFieldRules,
    password: {
      rules: 'required|password',
      messages: {
        required: false
      }
    },
    password2: {
      rules: 'required|matches[password]',
      messages: {
        required: false,
        matches: $.translate('The passwords does not match')
      }
    },
    approve_terms: {
      rules: 'required',
      messages: {
        required: false
      }
    }
  };

  // password reset 2 form rules
  window.validationRules.resetPasswordRules = {
    password: {
      rules: 'required|password',
      messages: {
        required: false
      }
    },
    password2: {
      rules: 'required|matches[password]',
      messages: {
        required: false,
        matches:  $.translate('The passwords does not match')
      }
    }
  };

  window.validationRules.purchaseDomainRulesOwnerName = {
    user: {
      rules: 'required|one_word|two_words|english',
      group: 'owner',
      messages: {
        required: $.translate('full name is required')
      }
    },
    company: {
      rules: 'required|english_numeric|words_count_min[2]',
      group: 'owner',
      messages: {
        required: $.translate('Company name is invalid'),
        words_count_min: $.translate('Company name is invalid')
      }
    }
  }

  // domain purchase domain admin rules
  window.validationRules.purchaseDomainRules = {
    // owner info section
    ownerEmail: {
      rules: 'required|valid_email',
      group: 'owner',
      messages: {
        required: $.translate('Email Is Required')
      }
    },
    ownerFullName: {
      rules: window.validationRules.purchaseDomainRulesOwnerName.user.rules,
      group: 'owner',
      messages: window.validationRules.purchaseDomainRulesOwnerName.user.messages
    },
    // rules switch to required|... when "registered company" is chosen ($.purchaseOwnerValidationRules in forms.js)
    ownerCompanyId: {
      rules: 'custom',
      group: 'owner',
      messages: $.extend({required: $.translate('Company number is required')}, window.validationRules.companyIdMessages),
      custom: $.extend({custom: function() { return true; }}, companyIdCallbacks('ownerAddressCountry'))
    },
    ownerAddressStreet: {
      rules: 'required|street|alpha_numeric_space_dot',
      group: 'owner',
      messages: {
        required: $.translate('Street is required')
      }
    },
    ownerAddressCity: {
      rules: 'required|english',
      group: 'owner',
      messages: {
        required: $.translate('City is required')
      }
    },
    ownerAddressZip: {
      rules: 'required|callback_valid_zip_code',
      group: 'owner',
      messages: {
        required: $.translate('Zip is required'),
        callback_valid_zip_code: $.translate('Zip is invalid')
      },
      custom: zipCallbacks('ownerAddressCountry')
    },
    ownerTel1: {
      rules: 'required|is_natural',
      group: 'owner'
    },
    ownerTel3: {
      rules: 'required|is_natural',
      group: 'owner'
    },
    ownerTel4: {
      rules: 'required|is_natural',
      group: 'owner',
      // disable validation if element is hidden
      depends: function(field) {
        var el = $(field.element);
        return !el.hasClass('hidden');
      }
    },
    ownerFax1: {
      rules: 'is_natural',
      group: 'owner'
    },
    ownerFax2: {
      rules: 'is_natural',
      group: 'owner'
    },
    ownerFax3: {
      rules: 'is_natural',
      group: 'owner'
    },

    // admin info section

    adminEmail: {
      rules: 'required|valid_email',
      group: 'admin',
      messages: {
        required: $.translate('Email Is Required')
      }
    },
    adminFullName: {
      rules: 'required|one_word|two_words|english',
      group: 'admin',
      messages: {
        required: $.translate('full name is required')
      }
    },
    adminAddressStreet: {
      rules: 'required|street|alpha_numeric_space_dot',
      group: 'admin',
      messages: {
        required: $.translate('Street is required')
      }
    },
    adminAddressCity: {
      rules: 'required|english',
      group: 'admin',
      messages: {
        required: $.translate('City is required')
      }
    },
    adminAddressZip: {
      rules: 'required|callback_valid_zip_code',
      group: 'admin',
      messages: {
        required: $.translate('Zip is required'),
        callback_valid_zip_code: $.translate('Zip is invalid')
      },
      custom: zipCallbacks('adminAddressCountry')
    },
    adminTel1: {
      rules: 'required|is_natural',
      group: 'admin'
    },
    adminTel3: {
      rules: 'required|is_natural',
      group: 'admin'
    },
    adminTel4: {
      rules: 'required|is_natural',
      group: 'admin',
      // disable validation if element is hidden
      depends: function(field) {
        var el = $(field.element);
        return !el.hasClass('hidden');
      }
    },
    adminFax1: {
      rules: 'is_natural',
      group: 'admin'
    },
    adminFax2: {
      rules: 'is_natural',
      group: 'admin'
    },
    adminFax3: {
      rules: 'is_natural',
      group: 'admin'
    },

    // purchase credit number validation
    creditNumber: {
      rules: 'required|valid_credit_card',
      messages: {
        required: false,
        valid_credit_card: $.translate('id is invalid')
      },
      group: 'payment'
    },
    creditExpirationYear: {
      rules: 'required|greater_than_current_year',
      messages: {
        greater_than_current_year: 'Year'
      },
      group: 'payment',
      custom: {
        greater_than_current_year: function(field) {
          return false;
        }
      }
    },
    creditExpirationMonth: {
      rules: 'required|greater_than_current_month',
      messages: {
        'greater_than_current_month': 'Month error'
      },
      group: 'payment',
      custom: {
        greater_than_current_month: function(field) {
          return false;
        }
      }
    }
  };

})(jQuery);